import {
  Button,
  FormControl,
  FormErrorMessage,
  HStack,
  Input,
  Text,
  Textarea,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import baseUrl from "../../vars";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { authFetch } from "../../auth/auth";

const AddDataForm = observer(() => {
  const toast = useToast();
  const { pageStore } = useStores();
  const initialValues = {
    dateCreated: "", 
    clients_processed: "", 
    calls_made: "", 
    lids_got: "", 
    lids_all_got: "", 
    lids_receller_got: "", 
    sent_to_purchase_dep: "", 
    commercial_offer: "", 
    sum_commercial_offer: "", 
    orders: "", 
    sum_orders: "", 
    pays: "", 
    report: "", 
  };

  const validationSchema = Yup.object({
    dateCreated: Yup.string().required("Обязательное поле"),
    clients_processed: Yup.string().required("Обязательное поле"),
    calls_made: Yup.string().required("Обязательное поле"),
    lids_got: Yup.string().required("Обязательное поле"),
    lids_all_got: Yup.string().required("Обязательное поле"),
    lids_receller_got: Yup.string().required("Обязательное поле"),
    sent_to_purchase_dep: Yup.string().required("Обязательное поле"),
    commercial_offer: Yup.string().required("Обязательное поле"),
    sum_commercial_offer: Yup.string().required("Обязательное поле"),
    orders: Yup.string().required("Обязательное поле"),
    sum_orders: Yup.string().required("Обязательное поле"),
    pays: Yup.string().required("Обязательное поле"),
    report: Yup.string().required("Обязательное поле"),
  });

  const onSubmit = async (values) => {
    const dataToSend = {
      ...values,
      user_email: pageStore.email,
    };

    const response = await authFetch(`${baseUrl}/api/reports`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${pageStore.token}`,
      },
      body: JSON.stringify(dataToSend),
    });
    if (response.ok) {
      toast({
        title: "Успех",
        description: "Форма успешно отправлена",
        duration: "3000",
        status: "success",
      });
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, touched, errors, handleChange, handleBlur }) => (
        <Form
          translate="no"
          autoComplete="off"
          style={{
            padding: 0,
            margin: 0,
          }}
        >
          <VStack align={"flex-start"} gap={"15px"} marginTop={"10px"}>
            <Text
              fontWeight={"600"}
              fontSize={"16px"}
              marginTop={"20px"}
              color={"myColor.white"}
            >
              Добавление данных
            </Text>

            {/* Дата */}
            <FormControl isInvalid={errors.dateCreated && touched.dateCreated}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Дата
              </Text>
              <Input
                type="date"
                value={values.dateCreated}
                autoComplete="new-password"
                placeholder="Выберите дату"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="dateCreated"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.dateCreated}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Проработано Клиентов в среднем за день */}
            <FormControl
              isInvalid={errors.clients_processed && touched.clients_processed}
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Проработано Клиентов в среднем за день
              </Text>
              <Input
                placeholder="Введите количество"
                value={values.clients_processed}
                autoComplete="new-password"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",

                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="clients_processed"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.clients_processed}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Звонков (больше 40 секунд) */}
            <FormControl isInvalid={errors.calls_made && touched.calls_made}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Звонков (больше 40 секунд)
              </Text>
              <Input
                type="number"
                value={values.calls_made}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="calls_made"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.calls_made}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Получено заявок */}
            <FormControl isInvalid={errors.lids_got && touched.lids_got}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Получено заявок
              </Text>
              <Input
                type="number"
                value={values.lids_got}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="lids_got"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.lids_got}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Получено лидов (всего) */}
            <FormControl
              isInvalid={errors.lids_all_got && touched.lids_all_got}
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Получено лидов (всего)
              </Text>
              <Input
                type="number"
                value={values.lids_all_got}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="lids_all_got"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.lids_all_got}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Получено лидов от перекупов */}
            <FormControl
              isInvalid={errors.lids_receller_got && touched.lids_receller_got}
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Получено лидов от перекупов
              </Text>
              <Input
                type="number"
                value={values.lids_receller_got}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="lids_receller_got"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.lids_receller_got}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Запущено в ОЗ */}
            <FormControl
              isInvalid={
                errors.sent_to_purchase_dep && touched.sent_to_purchase_dep
              }
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Запущено в ОЗ
              </Text>
              <Input
                type="number"
                value={values.sent_to_purchase_dep}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="sent_to_purchase_dep"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.sent_to_purchase_dep}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Выставлено КП */}
            <FormControl
              isInvalid={errors.commercial_offer && touched.commercial_offer}
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Выставлено КП
              </Text>
              <Input
                type="number"
                value={values.commercial_offer}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="commercial_offer"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.commercial_offer}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Общая сумма КП (Евро) */}
            <FormControl
              isInvalid={
                errors.sum_commercial_offer && touched.sum_commercial_offer
              }
            >
              <Text fontSize={"16px"} color={"myColor.white"}>
                Общая сумма КП (Евро)
              </Text>
              <Input
                type="number"
                placeholder="Введите сумму"
                autoComplete="new-password"
                value={values.sum_commercial_offer}
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  border: "none",
                  background: "#444",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="sum_commercial_offer"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.sum_commercial_offer}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Выставлено счетов */}
            <FormControl isInvalid={errors.orders && touched.orders}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Выставлено счетов
              </Text>
              <Input
                type="number"
                value={values.orders}
                autoComplete="new-password"
                placeholder="Введите количество"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="orders"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.orders}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Общая сумма счетов (Евро) */}
            <FormControl isInvalid={errors.sum_orders && touched.sum_orders}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Общая сумма счетов (Евро)
              </Text>
              <Input
                type="number"
                value={values.sum_orders}
                autoComplete="new-password"
                placeholder="Введите сумму"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="sum_orders"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.sum_orders}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Получено оплат (Руб) */}
            <FormControl isInvalid={errors.pays && touched.pays}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Получено оплат (Руб)
              </Text>
              <Input
                type="number"
                value={values.pays}
                autoComplete="new-password"
                placeholder="Введите сумму"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#EEEEEE",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="pays"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.pays}</Text>
              </FormErrorMessage>
            </FormControl>

            {/* Отчёт */}
            <FormControl isInvalid={errors.report && touched.report}>
              <Text fontSize={"16px"} color={"myColor.white"}>
                Отчёт
              </Text>
              <Textarea
                value={values.report}
                autoComplete="new-password"
                placeholder="Напишите краткий отчет"
                _placeholder={{ color: "#EEEEEE", fontWeight: "400" }}
                style={{
                  background: "#444",
                  border: "none",
                  color: "#00B2AC",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                name="report"
                width={"100%"}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <FormErrorMessage marginTop={"2px"}>
                <Text color={"red"}>{errors.report}</Text>
              </FormErrorMessage>
            </FormControl>

            <HStack width={"100%"} justify={"flex-end"} marginTop={"20px"}>
              <Button
                bg={"myColor.commonBlue"}
                _hover={{ bg: "myColor.darkBlue", color: "myColor.white" }}
                color={"myColor.white"}
              >
                Отменить
              </Button>
              <Button
                type="submit"
                bg={"myColor.commonBlue"}
                _hover={{ bg: "myColor.darkBlue", color: "myColor.white" }}
                color={"myColor.white"}
              >
                Добавить
              </Button>
            </HStack>
          </VStack>
        </Form>
      )}
    </Formik>
  );
});

export default AddDataForm;
